export default __webpack_public_path__ + "static/media/fileCheck.bd96e4aa.gif";